<template>
  <div class="dealResult">
    <el-row class="info_header">
      <el-col :span="24">
        <div class="drawer-subtitle_common">
          <span class="drawer-subtitle-text" v-if="getByIdFullData.status == 9">结果信息</span>
          <span class="drawer-subtitle-text" v-if="getByIdFullData.status != 9">处理信息</span>
        </div>
      </el-col>
      <!-- <el-col :span="10" style="text-align:right">
        <el-link
          type="primary"
          :underline="false"
          v-if="(getByIdFullData.status==9||getByIdFullData.status==7)&&logintype!=='SHOP'&&logintype!=='DEALER'"
          @click="changeDealOption"
        >修改处理结果</el-link>
      </el-col> -->
    </el-row>
    <el-card class="margin_top_bottom20">
      <!-- 展示 -->
      <el-form
        :label-width="labelWidth"
        v-if="(getByIdFullData.status==9||getByIdFullData.status==7)&&!dealOption"
      >
        <el-form-item label="结果说明：" :required="dealOption?true:false">
          <span>{{getByIdFullData.result}}</span>
        </el-form-item>
        <el-form-item label="处理说明：" v-if="getByIdFullData.status != 9">
          <span>{{getByIdFullData.decisions}}</span>
        </el-form-item>
      </el-form>
      <!-- 处理 -->
      <el-form :label-width="labelWidth" v-if="showDealStatus">
        <el-form-item label="处理结果：" :required="true">
          <el-select filterable v-model="deal.result" size="small" style="width:90%">
            <el-option v-for="item in InstallList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理说明：">
          <el-input
            style="width:90%"
            type="textarea"
            placeholder="请输入说明，请保持在200字以内。"
            maxlength="200"
            class="check_textarea"
            v-model="deal.decisions"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        v-if="getByIdFullData.status==7&&(logintype==='SHOP'||logintype==='DEALER')&&secondTime&&violateSetInfo.repleader"
      >
        <div class="hint_word_orange">
          <i class="el-icon-warning"></i>
          如对上述的处理结果存有异议，可进行二次申诉。剩余申诉时间：{{secondTime}}。
        </div>
      </div>
    </el-card>

    <div style="text-align:right;">
      <el-button
        type="primary"
        size="small"
        @click="twiceDeal"
        v-if="getByIdFullData.status==7&&(logintype==='SHOP'||logintype==='DEALER')&&secondTime&&violateSetInfo.repleader&&!appealShow"
      >我要二次申诉</el-button>
    </div>

    <!-- 待店铺二次申诉 -->
    <div v-if="appealShow">
      <div class="drawer-subtitle_common">
        <span>二次申诉信息</span>
      </div>
      <el-card class="margin_top_bottom20">
        <el-form :label-width="labelWidth">
          <el-form-item label="二次申诉截图：" :required="true">
            <uploadPic @getpic="getpic" ref="twoUploadPics"></uploadPic>
          </el-form-item>
          <el-form-item label="二次申诉理由：" :required="true">
            <el-input
              type="textarea"
              placeholder="请输入申诉理由，请保持在200字以内。"
              maxlength="200"
              class="check_textarea"
              v-model="twice.reportexplain"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { getLoginType } from "@/libs/until";
import uploadPic from "@/views/CreditScore/common/uploadPic";
import { Djs_timeListDay } from "@/libs/date";

export default {
  data() {
    return {
      labelWidth: "130px",
      dealResultcheck: "",
      deal: {
        decisions: "",
        result: ""
      },
      twice: {
        reportexplain: "",
        reportpic: ""
      },
      dealOption: false, //处理的输入框
      logintype: getLoginType(),
      appealShow: false,
      secondTime: false
    };
  },
  computed: {
    ...mapState({
      InstallList: state => state.creditScore.InstallList,
      violateSetInfo: state => state.creditScore.violateSetInfo
    }),
    ...mapGetters(["getByIdFullData"]),
    showDealStatus() {
      let status = this.getByIdFullData.status;
      let logintype = this.logintype;
      if (
        (status == 3 ||
          status == 4 ||
          status == 5 ||
          status == 6 ||
          status == 8) &&
        logintype !== "SHOP" &&
        logintype !== "DEALER"
      ) {
        return true;
      } else if (this.dealOption) {
        return true;
      } else {
        return false;
      }
    }
  },
  components: { uploadPic },
  created() {
    this.timeListDay();
  },
  methods: {
    timeListDay() {
      //二次申诉剩余时间
      let time = Djs_timeListDay(
        this.getByIdFullData.flowtime,
        Number(this.violateSetInfo.secondAppealTime)*60 * 24
      );
        let str=false
        if(time.length>0)str=time[0]==0?time[0]+'天'+time[1]+'时':time[0]+'天'
      this.secondTime=str
    },
    twiceDeal() {
      this.appealShow = true;
      this.$emit("showShopDealBtn");
      this.$emit("scrollBottom");
    },
    changeDealOption() {
      this.dealOption = true;
      this.$emit("showDealBtn");
    },
    toResult() {
      this.deal.result = this.getByIdFullData.result;
      this.deal.decisions = this.getByIdFullData.decisions;
    },
    getpic() {
      this.twice.reportpic = String(this.$refs.twoUploadPics.uploadPicHtpp);
    }
  }
};
</script>
<style lang="scss">
.dealResult {
  .check_textarea {
    .el-textarea__inner {
      height: 100px;
    }
  }
}
</style>
